import React from 'react';
import { scrollToTop } from '../header';
import './style.css'

const Scrollbar = () => {
    return(
        <div className="col-lg-12">
            <div className="header-menu">
                <ul className="smothscroll">
                    <li><button onClick={() => scrollToTop()} aria-label="Scroll to top"><i className="ti-arrow-up"></i></button></li>
                </ul>
            </div>
        </div>
    )
}

export default Scrollbar;
